export const LaptopDevModeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g id="iconoir:laptop-dev-mode">
        <g id="Group">
          <path
            id="Vector"
            d="M3.69994 14.93V4.70801C3.69994 4.17757 3.91065 3.66887 4.28572 3.29379C4.6608 2.91872 5.1695 2.70801 5.69994 2.70801H19.2999C19.8304 2.70801 20.3391 2.91872 20.7142 3.29379C21.0892 3.66887 21.2999 4.17757 21.2999 4.70801V14.93M3.69994 14.93H21.2999M3.69994 14.93L2.21994 20.164C2.13588 20.4614 2.12188 20.7742 2.17904 21.0779C2.23619 21.3816 2.36295 21.6679 2.54936 21.9144C2.73577 22.1609 2.97676 22.3608 3.25343 22.4985C3.53009 22.6362 3.8349 22.7079 4.14394 22.708H20.8559C21.165 22.7079 21.4698 22.6362 21.7464 22.4985C22.0231 22.3608 22.2641 22.1609 22.4505 21.9144C22.6369 21.6679 22.7637 21.3816 22.8208 21.0779C22.878 20.7742 22.864 20.4614 22.7799 20.164L21.2999 14.93"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            id="Vector_2"
            d="M11.5 19.708H13.5M14.5 6.70801L16.5 8.70801L14.5 10.708M10.5 6.70801L8.5 8.70801L10.5 10.708"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
